import { render, staticRenderFns } from "./tenchat.vue?vue&type=template&id=20770f94"
import script from "./tenchat.vue?vue&type=script&lang=js"
export * from "./tenchat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports